/* eslint-disable */

import config from 'config';

export let _ssoWindow;

export const handleSsoSelection = (ssoProvider) => {
	const popUpWindowWidth = 600;
	const popUpWindowHeight = 600;
	const y = window.outerHeight / 2 + window.screenY - popUpWindowHeight / 2;
	const x = window.outerWidth / 2 + window.screenX - popUpWindowWidth / 2;
	const name = ssoProvider.humanReadableName;
	const url = `${config.extensionAppUrl}/sso.html?redirectUrl=${ssoProvider.ssoUriForMobile}`;

	_ssoWindow = window.open(
		url,
		name,
		`width=${popUpWindowWidth}, height=${popUpWindowHeight}, top=${y}, left=${x}`
	);
};
